/* eslint-disable camelcase */
// Search
import searchPeopleConfig from './search-people.config';
import searchWitnessesConfig from './search-witnesses.config';
import searchBibliographyConfig from './search-bibliography.config';
import searchBooksConfig from './search-books.config';
import searchIconographiesConfig from './search-iconographies.config';
import searchToolsConfig from './search-tools.config';
import searchBiographiesConfig from './search-biographies.config';
// Resource
import resourcePersonConfig from './resource-person.config';
import resourceVoyageConfig from './resource-voyage.config'
import resourceWitnessConfig from './resource-witness.config';
import resourceBibliographyConfig from './resource-bibliography.config';
import resourceModalBibliography_witConfig from './resource-modal-bibliography_wit.config';
import resourceBookConfig from './resource-book.config';
import resourceToponymConfig from './resource-toponym.config';
import resourceIconographyConfig from './resource-iconography.config';
import resourceBiographyConfig from './resource-biography.config';
import resourceToolConfig from './resource-tool.config';
import resourceKeywordConfig from './resource-keyword.config';
// Others
import homeConfig from './home.config';
import itineraryConfig from './itinerary.config';


export default {
  // Search
  'search-people': searchPeopleConfig,
  'search-witnesses': searchWitnessesConfig,
  'search-books': searchBooksConfig,
  'search-tools': searchToolsConfig,
  'search-biographies': searchBiographiesConfig,
  'search-iconographies': searchIconographiesConfig,
  'search-bibliography': searchBibliographyConfig,
  // Resource
  'resource-person': resourcePersonConfig,
  'resource-voyage': resourceVoyageConfig,
  'resource-biography': resourceBiographyConfig,
  'resource-tool': resourceToolConfig,
  'resource-iconography': resourceIconographyConfig,
  'resource-witness': resourceWitnessConfig,
  'resource-book': resourceBookConfig,
  'resource-toponym': resourceToponymConfig,
  'resource-keyword': resourceKeywordConfig,
  'resource-bibliography': resourceBibliographyConfig,
  'resource-modal-bibliography_wit': resourceModalBibliography_witConfig,
  // Others
  home: homeConfig,
  itinerary: itineraryConfig,
};
